module.exports = __webpack_public_path__ + "static/img/how-to-join-step-1.a983d44.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fifa2026/images/how-to-join-step-1.png
// module id = 7Zeo
// module chunks = 1